import React, { useEffect, useState } from 'react';
import { useStomp } from '@root/providers';
import { journeySelector } from '@root/store/slices/journeySlice';
import { useTypedSelector } from '@root/store/store';
import { useTranslation } from 'react-i18next';
import StatusDialog from '../StatusDialog';

// Only speak up once the wait is long enough to worry about.
const CONFIRMING_AFTER_MS = 1500;

const ConnectionStatus: React.FC = () => {
  const { t } = useTranslation();
  const { connected, connect } = useStomp();
  const { rollSubmitted } = useTypedSelector(journeySelector);
  const [confirming, setConfirming] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!rollSubmitted) {
      setConfirming(false);
      setDismissed(false);
      return;
    }
    const timer = window.setTimeout(
      () => setConfirming(true),
      CONFIRMING_AFTER_MS
    );
    return () => window.clearTimeout(timer);
  }, [rollSubmitted]);

  // A dropped socket is the bigger problem, so it wins.
  if (!connected) {
    return (
      <StatusDialog
        title={t('Reconnecting…')}
        lead={t(
          'We’re restoring your latest round. Automatic rolls may continue while you are away.'
        )}
        detail={t(
          'Your board and any settled result will appear when connection returns.'
        )}
        action={{ label: t('RETRY CONNECTION'), onClick: () => connect() }}
        onClose={() => undefined}
      />
    );
  }

  if (!confirming || dismissed) return null;

  return (
    <StatusDialog
      title={t('Confirming your roll')}
      lead={t(
        'Your transaction is still being confirmed. Please wait; do not place another roll.'
      )}
      detail={t('No extra charge will be made for retrying confirmation.')}
      onClose={() => setDismissed(true)}
    />
  );
};

export default ConnectionStatus;
